import React from "react";
import PropTypes from "prop-types";
import {inject} from "mobx-react";
import {action, observable} from "mobx";
import './PageTitle.scss'

@inject(({ common }) => ({ getCurNav: common.getCurNav }))
class PageTitle extends React.Component {

  @observable navInfo = this.props.getCurNav();

  constructor(props) {
    super(props);

    this.init();
  }

  @action
  init = async (key) => {

     //console.log(this.navInfo)

  };


  render() {
    const nav = this.navInfo || {};
    const mainMenu = nav.mainMenu || null;
    const submenu = nav.submenu || null;

    return (
      <div className="content-top-area">
        <div className="location">
          {mainMenu && <span>{mainMenu.label}</span>}

          {submenu ? (
            <span>
              {submenu.middleMenu ? (
                <>{submenu.middleMenu} - </>
              ) : null }
              {submenu.label}</span>
            ) : null }
        </div>
        {submenu ? (
          <div className="content-title">
            <h2>{submenu.label}</h2>
          </div>
        ) : null }
        {this.props.navExtra ? (
          <div className="page-title-extra">{this.props.navExtra}</div>
        ) : null }
      </div>
    )
  }
}

PageTitle.propTypes = {
  info: PropTypes.object,
  hideLogoText: PropTypes.bool,
  navExtra: PropTypes.node
};

PageTitle.defaultProps = {
  info: {},
  hideLogoText: false,
  navExtra: null
};

export default PageTitle;
